import axios from 'axios';
import setJwtToken from './setJwtToken';
const REFRESH_INTERVAL = 10000;

const roleToIdMap = {
  admin: 1,
  user: 2,
};

const logout = () => {
  localStorage.removeItem('jwtToken');
  localStorage.removeItem('refreshToken');
};

const authorizationService = {
  canAccessAdminPanel: (user) => {
    const roles = user.roles || [];
    if (roles.find((r) => r.id === roleToIdMap.admin)) {
      return true;
    }
  },
  startRefresh: () => {
    const intervalId = setInterval(async () => {
      const accessToken = localStorage.getItem('jwtToken');
      const refreshToken = localStorage.getItem('refreshToken');

      if (!accessToken || !refreshToken) {
        return;
      }

      const response = await axios.post('/api/user/refresh-token', {
        token: accessToken,
        refreshToken,
      });

      if (!response.data.success) {
        clearInterval(intervalId);
        logout();
        return;
      }

      localStorage.setItem('jwtToken', response.data.token);
      localStorage.setItem('refreshToken', response.data.refreshToken);
      setJwtToken(accessToken);
    }, REFRESH_INTERVAL);
  },
};

export default authorizationService;

